module.exports = __webpack_public_path__ + "img/imago-citiaps-blanco.716cc916.svg";